import { Autocomplete, Button, Dialog, TextField } from '@acheloisbiosoftware/absui.core';
import { ENTITY_CATEGORY, ENTITY_SOP } from 'constants/schemas';
import React, { useState } from 'react';

import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { ShareIcon } from 'constants/icon.constants';
import { ShareNewDocumentField } from 'components/Shares';
import Stack from '@mui/material/Stack';
import { formatType } from 'utils/entity.utils';
import { mergeSx } from '@acheloisbiosoftware/absui.utils';

function NewSopFormInline(props) {
  const {
    formData,
    updateFormData,
    excludeFields,
    fieldPropsMap,
    categoryAutocompleteProps,
    containerProps,
  } = props;
  const { title, is_template, permission_relationships } = formData;

  const numShares = (permission_relationships ?? []).length;
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  return (
    <Stack direction='row' alignItems='center' {...containerProps}>
      { excludeFields.includes('title') ? null : (
        <TextField
          variant='standard'
          size='small'
          label='Title'
          value={title}
          onChange={(_, newTitle) => updateFormData('title', newTitle)}
          {...fieldPropsMap?.title}
        />
      )}
      { excludeFields.includes('category') ? null : (
        <Autocomplete
          label={formatType(ENTITY_CATEGORY)}
          inputProps={(params) => ({
            ...params,
            size: 'small',
            variant: 'standard',
            ...categoryAutocompleteProps?.inputProps?.(params),
            ...fieldPropsMap?.category?.inputProps?.(params),
          })}
          {...categoryAutocompleteProps}
          {...fieldPropsMap?.category}
          sx={mergeSx(
            { minWidth: 150 },
            categoryAutocompleteProps?.sx,
            fieldPropsMap?.category?.sx,
          )}
        />
      )}
      { excludeFields.includes('permission_relationships') ? null : (
        <Box sx={{ color: 'text.icon' }}>
          <Button
            variant='text'
            color={numShares > 0 ? 'primary' : 'inherit'}
            onClick={() => setShareDialogOpen(true)}
            startIcon={<ShareIcon />}
          >
            {numShares}
          </Button>
          <Dialog
            title={`Share New ${formatType(ENTITY_SOP, { template: is_template })}`}
            open={shareDialogOpen}
            onConfirm={() => setShareDialogOpen(false)}
            confirmOnly
            fullWidth
            maxWidth='sm'
          >
            <ShareNewDocumentField
              shares={permission_relationships}
              setShares={(newShares) => updateFormData('permission_relationships', newShares)}
              {...fieldPropsMap?.permission_relationships}
            />
          </Dialog>
        </Box>
      )}
    </Stack>
  );
}

NewSopFormInline.propTypes = {
  formData: PropTypes.object,
  updateFormData: PropTypes.func,
  excludeFields: PropTypes.arrayOf(PropTypes.string),
  fieldPropsMap: PropTypes.object,
  categoryAutocompleteProps: PropTypes.object,
  containerProps: PropTypes.object,
};

export default NewSopFormInline;
